module.exports = __webpack_public_path__ + "static/img/wzry-companyProducts5.4814aa0b.png";